import { AxiosResponse } from "axios";
import { Axios } from "../Axios";
import { ContaEncerramentoType, EnumTipoConta, TypeConta } from "../../Models/Financeiro/Conta";
import { QueryKey, UndefinedInitialDataOptions, useMutation, useQuery } from "@tanstack/react-query";
import RequestUtilitario, { MutationBasicaParam } from "@/Utils/RequisicaoUtilitario";
import { queryClient } from "@/App";
export class ContaService {
    public listar(conta: TypeConta, encerrada?:boolean, codCentrosDeCustosADV?:number[], codTiposInvalidos?:EnumTipoConta[]): Promise<AxiosResponse<TypeConta[]>> {
        const queryString = RequestUtilitario.objectToQueryString({
            encerrada,
            codCentrosDeCustosADV,
            codTiposInvalidos
        });

        console.log("queryString: ", queryString)

        return Axios.post<TypeConta[]>(`conta/listar?${queryString}`, conta);
    }

    public inserir(conta: TypeConta) {
        return Axios.post('conta/inserir', conta);
    }

    public atualizar(conta: TypeConta){
        return Axios.put<TypeConta>('conta/atualizar', conta);
    }

    public ativar(codigoDaConta: number){
        return Axios.patch(`conta/ativar/${codigoDaConta}`);
    }

    public desativar(codigoDaConta: number){
        return Axios.patch(`conta/desativar/${codigoDaConta}`);
    }
}

type QueryParam<TResponse, TResponseSelect = TResponse, TAdicional = any, TErro = Error, TQueryKey extends QueryKey = QueryKey> = 
    Omit<UndefinedInitialDataOptions<TResponse, TErro, TResponseSelect, TQueryKey>, "queryKey"> & TAdicional & { queryKey?:TQueryKey }
;
export function useListarContas({
    contaParam,
    encerrada,
    codCentrosDeCustosADV,
    codTiposInvalidos,
    ...rest
}:QueryParam<
    AxiosResponse<TypeConta[], any>, 
    TypeConta[], 
    { contaParam ?: TypeConta, encerrada?:boolean, codCentrosDeCustosADV?:number[], codTiposInvalidos?:EnumTipoConta[] }
>) {
    const queryString = RequestUtilitario.objectToQueryString({
        contaParam,
        encerrada,
        codCentrosDeCustosADV,
        codTiposInvalidos
    });
    return useQuery({
        ...rest,
        queryKey : ["Financeiro.Conta.Listar", `Financeiro.Conta.Listar?${queryString}}`],
        queryFn : () => new ContaService().listar((contaParam ?? {}) as TypeConta, encerrada, codCentrosDeCustosADV, codTiposInvalidos),
        select : (data) => data.data,
        staleTime : 1000 * 60 * 0.1
    });
}

export function useContaEncerrar({
    onSuccess,
    ...rest
}:MutationBasicaParam<ContaEncerramentoType, AxiosResponse<void>, {}>) {
    return useMutation({
        ...rest,
        mutationFn : (entrade) => Axios.patch<void>('conta/encerrar', entrade),
        onSuccess(data, variables, context) {
            queryClient.invalidateQueries({
                queryKey : ["Financeiro.Conta.Listar"]
            });

            onSuccess?.(data, variables, context);
        }
    });
}